import { useEffect, useState } from "react";
import { adminApi } from "@/lib/adminApi";

const cache = new Map();

export const useAuthImage = (path, version) => {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    let alive = true;
    const key = `${path}|${version}`;
    if (cache.has(key)) { setUrl(cache.get(key)); return undefined; }
    adminApi.get(path, { responseType: "blob" }).then((r) => {
      const u = URL.createObjectURL(r.data);
      cache.set(key, u);
      if (alive) setUrl(u);
    }).catch(() => alive && setUrl(null));
    return () => { alive = false; };
  }, [path, version]);
  return url;
};

export const AuthImage = ({ path, version, alt, className, testId, onClick }) => {
  const url = useAuthImage(path, version);
  return url ? <img src={url} alt={alt} className={className} onClick={onClick} data-testid={testId} /> : <span className={`${className} td-img-loading`} data-testid={testId} />;
};
